import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AppRoutes from "./routes/AppRoutes";

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen dark:bg-gray-900 dark:text-white">
        <Navbar />
        <main className="flex-grow">
          <div className=" w-full mx-auto">
            <AppRoutes />
          </div>
        </main>
        <Footer />
      </div>
    </Router>
  );
}


export default App;
